module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starFull-481a2ceb387537716a206699aaf52947.png";